import React from 'react';
import '../blocks/ModernBlocks.css';

const PortfolioBlock = ({ data }) => {
  return (
    <section className="portfolio-section">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <h2 className="portfolio-title">{data.title}</h2>
          <p className="portfolio-subtitle">{data.subtitle}</p>
        </div>
        
        <div className="portfolio-grid">
          {data.categories.map((category, index) => (
            <div key={index} className="portfolio-category">
              <div className="portfolio-image">
                <img src={category.image} alt={category.name} />
                <div className="portfolio-overlay">
                  <div className="portfolio-content">
                    <h3 className="portfolio-category-name">{category.name}</h3>
                    <div className="portfolio-count">{category.count}</div>
                    <p className="portfolio-description">{category.description}</p>
                    <button className="portfolio-view-btn">View Projects</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="portfolio-stats">
          <div className="portfolio-stat">
            <div className="stat-number">5,000+</div>
            <div className="stat-label">Total Installations</div>
          </div>
          <div className="portfolio-stat">
            <div className="stat-number">15+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="portfolio-stat">
            <div className="stat-number">98%</div>
            <div className="stat-label">Success Rate</div>
          </div>
          <div className="portfolio-stat">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioBlock; 